import * as React from 'react';
import { CorePageWrapper } from '../../designSystem/layouts/pageWrappers/CorePageWrapper';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { H2 } from '../../designSystem/typography/Heading';
import { PageHeader } from '../../designSystem/PageHeader';


export default function InsufficientPermissionPage(): JSX.Element{

    
    
    return ( 
        <CorePageWrapper activeUser={null} loading={false} hideMenu>
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        <PageHeader headerText="Du mangler brugerrettigheder" headerStyle="secondary-gray" />

                        <H2>Du har forsøgt at tilgå funktionalitet som du ikke har rettigheder til</H2>
                        <p>
                            Det er sandsynligvis en forglemmelse fra din administrators side. Tag fat i en AMORG administrator i din arbejdsmiljøorganisation.
                            Vedkommende kan rette din adgang med det samme.<br />
                            <br />
                            Mvh. AMORG
                        </p>
                    </>
                }
            />
        </CorePageWrapper>

    );
}